import { useState } from 'react';
import { whatsappUtils } from 'api/whatsappUtilsApi';

export const useDashboard = () => {
	const [ negotiationDashboard, setNegotiationDashboard ] = useState( null );
	const [ isLoading, setIsLoading ] = useState( false );
	const [ selectedNegotiators, setSelectedNegotiators ] = useState( [] );
	const [ allNegotiators, setAllNegotiators ] = useState( [] );
	const [ currentPage, setCurrentPage ] = useState( 1 );
	const [ itemsPerPage ] = useState( 10 );
	const [ sortConfig, setSortConfig ] = useState( { key: 'dealsClosed', direction: 'desc' } );

	const consolidateNegotiatorData = ( responseData ) => {
		const negotiatorsMap = {};

		// Processar activeChatsByUser
		if ( responseData.activeChatsByUser && Array.isArray( responseData.activeChatsByUser ) ) {
			responseData.activeChatsByUser.forEach( item => {
				const email = item?.userEmail;
				const INVALID_NEGOTIATOR_EMAIL = [ 'workflow@acordofechado.com.br', 'jarvis@acordofechado.com.br' ];
				if ( email && !INVALID_NEGOTIATOR_EMAIL.includes( email ) ) {
					if ( !negotiatorsMap[email] ) {
						negotiatorsMap[email] = {
							userEmail       : email,
							departmentName  : item?.departmentName || '',
							activeChats     : 0,
							dealsClosed     : 0,
							startedMessages : 0,
							unreadCount     : 0,
							callsMade       : 0,
							callsWithResponse : 0,
						};
					}
					negotiatorsMap[email].activeChats = item.activeChats || 0;
					negotiatorsMap[email].unreadCount = item.unreadCount || 0;
					negotiatorsMap[email].callsMade = item.callsMade || 0;
					negotiatorsMap[email].callsWithResponse = item.callsWithResponse || 0;
					// Atualizar departmentName se disponível
					if ( item?.departmentName ) {
						negotiatorsMap[email].departmentName = item.departmentName;
					}
				}
			} );
		}

		// Processar dealClosedByNegotiators
		if ( responseData.dealClosedByNegotiators && Array.isArray( responseData.dealClosedByNegotiators ) ) {
			responseData.dealClosedByNegotiators.forEach( item => {
				const email = item?.userEmail;
				const INVALID_NEGOTIATOR_EMAIL = [ 'workflow@acordofechado.com.br', 'jarvis@acordofechado.com.br' ];
				if ( email && !INVALID_NEGOTIATOR_EMAIL.includes( email ) ) {
					if ( !negotiatorsMap[email] ) {
						negotiatorsMap[email] = {
							userEmail       : email,
							departmentName  : item?.departmentName || '',
							activeChats     : 0,
							dealsClosed     : 0,
							startedMessages : 0,
							callsMade		: 0,
							callsWithResponse: 0, 
						};
					}
					negotiatorsMap[email].dealsClosed = item.dealsClosed || 0;
					// Atualizar departmentName se disponível
					if ( item?.departmentName ) {
						negotiatorsMap[email].departmentName = item.departmentName;
					}
				}
			} );
		}

		// Processar startedMessagesByUser
		if ( responseData.startedMessagesByUser && Array.isArray( responseData.startedMessagesByUser ) ) {
			responseData.startedMessagesByUser.forEach( item => {
				const email = item?.userEmail;
				const INVALID_NEGOTIATOR_EMAIL = [ 'workflow@acordofechado.com.br', 'jarvis@acordofechado.com.br' ];
				if ( email && !INVALID_NEGOTIATOR_EMAIL.includes( email ) ) {
					if ( !negotiatorsMap[email] ) {
						negotiatorsMap[email] = {
							userEmail       : email,
							departmentName  : item?.departmentName || '',
							activeChats     : 0,
							dealsClosed     : 0,
							startedMessages : 0,
							callsMade		: 0,
							callsWithResponse: 0, 
						};
					}
					negotiatorsMap[email].startedMessages = item.startedMessages || 0;
					// Atualizar departmentName se disponível
					if ( item?.departmentName ) {
						negotiatorsMap[email].departmentName = item.departmentName;
					}
				}
			} );
		}

		// Processar callsMadeByNegotiators
		if ( responseData.callsMadeByNegotiators && Array.isArray( responseData.callsMadeByNegotiators ) ) {
			responseData.callsMadeByNegotiators.forEach( item => {
				const email = item?.userEmail;
				const INVALID_NEGOTIATOR_EMAIL = [ 'workflow@acordofechado.com.br', 'jarvis@acordofechado.com.br' ];
				if ( email && !INVALID_NEGOTIATOR_EMAIL.includes( email ) ) {
					if ( !negotiatorsMap[email] ) {
						negotiatorsMap[email] = {
							userEmail       : email,
							departmentName  : item?.departmentName || '',
							activeChats     : 0,
							dealsClosed     : 0,
							startedMessages : 0,
							callsMade		: 0,
							callsWithResponse: 0, 
						};
					}
					negotiatorsMap[email].callsMade = item.callsMade || 0;
					// Atualizar departmentName se disponível
					if ( item?.departmentName ) {
						negotiatorsMap[email].departmentName = item.departmentName;
					}
				}
			} );
		}

		// Processar callsWithResponseByNegotiator
		if ( responseData.callsWithResponseByNegotiator && Array.isArray( responseData.callsWithResponseByNegotiator ) ) {
			responseData.callsWithResponseByNegotiator.forEach( item => {
				const email = item?.userEmail;
				const INVALID_NEGOTIATOR_EMAIL = [ 'workflow@acordofechado.com.br', 'jarvis@acordofechado.com.br' ];
				if ( email && !INVALID_NEGOTIATOR_EMAIL.includes( email ) ) {
					if ( !negotiatorsMap[email] ) {
						negotiatorsMap[email] = {
							userEmail       : email,
							departmentName  : item?.departmentName || '',
							activeChats     : 0,
							dealsClosed     : 0,
							startedMessages : 0,
							callsMade		: 0,
							callsWithResponse: 0, 
						};
					}
					negotiatorsMap[email].callsWithResponse = item.callsWithResponse || 0;
					// Atualizar departmentName se disponível
					if ( item?.departmentName ) {
						negotiatorsMap[email].departmentName = item.departmentName;
					}
				}
			} );
		}

		// Converter o mapa em array e ordenar
		const negotiatorsArray = Object.values( negotiatorsMap );
		
		// Ordenar por negociadores que têm dados primeiro (soma dos valores > 0)
		return negotiatorsArray.sort( ( a, b ) => {
			const aTotalActivity = a.activeChats + a.dealsClosed + a.startedMessages;
			const bTotalActivity = b.activeChats + b.dealsClosed + b.startedMessages;
			
			// Se um tem atividade e outro não, priorizar o que tem atividade
			if ( aTotalActivity > 0 && bTotalActivity === 0 ) return -1;
			if ( aTotalActivity === 0 && bTotalActivity > 0 ) return 1;
			
			// Se ambos têm atividade ou ambos não têm, ordenar por total de atividade (decrescente)
			if ( aTotalActivity !== bTotalActivity ) {
				return bTotalActivity - aTotalActivity;
			}
			
			// Se têm a mesma atividade total, ordenar alfabeticamente por email
			return a.userEmail.localeCompare( b.userEmail );
		} );
	};

	const getNegotiationDashboard = async ( dateFilter = null ) => {
		setIsLoading( true );
		const payload = {};
		
		// Adicionar dateFilter ao payload apenas se startDate e endDate estiverem presentes
		if ( dateFilter && dateFilter.startDate && dateFilter.endDate ) {
			payload.dateFilter = {
				startDate : dateFilter.startDate,
				endDate   : dateFilter.endDate
			};
		}
		
		const response = await whatsappUtils.getNegotiationDashboard( payload );
		
		// Consolidar dados dos negociadores
		const consolidatedNegotiators = consolidateNegotiatorData( response.data );
		
		// Armazenar todos os negociadores para o filtro
		setAllNegotiators( consolidatedNegotiators );
		
		// Filtrar negociadores baseado na seleção (se houver seleção, senão mostra todos)
		let filteredNegotiators = selectedNegotiators.length > 0 
			? consolidatedNegotiators.filter( negotiator => selectedNegotiators.includes( negotiator.userEmail ) )
			: consolidatedNegotiators;
		
		// Aplicar ordenação inicial
		filteredNegotiators = sortData( filteredNegotiators, sortConfig );
		
		response.data = {
			totalClosedDeals: ( response?.data?.totalDealsClosedByIA ?? 0 ) + ( response?.data?.totalDealClosedByNegotiators ?? 0 ),
			...response?.data,
		};
		
		setNegotiationDashboard( { data             : response.data, negotiatorsTable : filteredNegotiators,
			IaKeys           : [
				'totalDealsClosedByIA',
				'totalActiveChatsJarvis',
				'totalStartedMessagesJarvis',
				'totalUnreadCountJarvis',
				'totalCallsMadeByIA',
				'totalCallsMadeByIAWithAnswer'
			],
			negotiatorsKeys: [
				'totalDealClosedByNegotiators',
				'totalActiveChatsNegotiators',
				'totalStartedMessagesNegotiators',
				'totalUnreadCountNegotiators',
				'totalCallsMadeByNegotiators',
				'totalCallsMadeByNegotiatorsWithAnswer'
			]
		 } );
		setIsLoading( false );
	};

	// Função para calcular dados paginados
	const getPaginatedData = ( data, page, itemsPerPage ) => {
		const startIndex = ( page - 1 ) * itemsPerPage;
		const endIndex = startIndex + itemsPerPage;
		return data.slice( startIndex, endIndex );
	};

	// Função para ordenar dados
	const sortData = ( data, sortConfig ) => {
		if ( !sortConfig.key ) return data;
		
		const sortedData = [ ...data ].sort( ( a, b ) => {
			const aValue = a[sortConfig.key] || 0;
			const bValue = b[sortConfig.key] || 0;
			
			if ( sortConfig.direction === 'desc' ) {
				return bValue - aValue;
			}
			return aValue - bValue;
		} );
		
		return sortedData;
	};

	// Função para atualizar o filtro de negociadores
	const handleNegotiatorFilterChange = ( selectedEmails ) => {
		setSelectedNegotiators( selectedEmails );
		setCurrentPage( 1 ); // Reset para primeira página quando filtrar
		
		// Aplicar filtro aos dados existentes
		if ( allNegotiators.length > 0 ) {
			let filteredNegotiators = selectedEmails.length > 0 
				? allNegotiators.filter( negotiator => selectedEmails.includes( negotiator.userEmail ) )
				: allNegotiators;
			
			// Aplicar ordenação
			filteredNegotiators = sortData( filteredNegotiators, sortConfig );
			
			setNegotiationDashboard( prev => ( {
				...prev,
				negotiatorsTable: filteredNegotiators,
			} ) );
		}
	};

	// Função para alterar ordenação
	const handleSortChange = ( key ) => {
		let direction = 'desc';
		
		// Se já está ordenando pela mesma coluna, alterna direção
		if ( sortConfig.key === key && sortConfig.direction === 'desc' ) {
			direction = 'asc';
		}
		
		const newSortConfig = { key, direction };
		setSortConfig( newSortConfig );
		
		// Aplicar nova ordenação aos dados existentes
		if ( negotiationDashboard?.negotiatorsTable ) {
			const sortedData = sortData( negotiationDashboard.negotiatorsTable, newSortConfig );
			setNegotiationDashboard( prev => ( {
				...prev,
				negotiatorsTable: sortedData
			} ) );
		}
		
		setCurrentPage( 1 ); // Reset para primeira página
	};

	// Função para mudar página
	const handlePageChange = ( newPage ) => {
		setCurrentPage( newPage );
	};

	// Calcular dados paginados baseados nos dados filtrados
	const paginatedNegotiators = negotiationDashboard?.negotiatorsTable 
		? getPaginatedData( negotiationDashboard.negotiatorsTable, currentPage, itemsPerPage )
		: [];

	// Calcular total de páginas
	const totalPages = negotiationDashboard?.negotiatorsTable 
		? Math.ceil( negotiationDashboard.negotiatorsTable.length / itemsPerPage )
		: 0;

	return { 
		negotiationDashboard, 
		getNegotiationDashboard, 
		isLoading, 
		allNegotiators, 
		selectedNegotiators, 
		handleNegotiatorFilterChange,
		paginatedNegotiators,
		currentPage,
		totalPages,
		handlePageChange,
		itemsPerPage,
		sortConfig,
		handleSortChange
	};
};